import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/logo/logo-home.svg'


const _hoisted_1 = { class: "app-no-overflow" }
const _hoisted_2 = { class: "body-background-overlay" }
const _hoisted_3 = {
  key: 1,
  class: "h-100 f f-center-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "app-logo mb-6",
  alt: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "a-appear-bounce-up"
}

import { ref, Ref, computed } from "vue";
import { playMusic } from "@/helpers/sound";
import SpinnerIcon from "./elements/SpinnerIcon.vue";
import { useStore } from "vuex";
import { get } from "./helpers/api";
import { t } from "./helpers/i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

const isOnline = ref(false);
const isRouteLoading = computed(() => store.getters.isRouteLoading);

const error: Ref<string | null> = ref(null);

get("/auth/check", {
    200: handleSignedIn,
    400: handleNotSignedIn,
    404: handleOffline,
});

function handleSignedIn(data: object) {
    store.commit("signIn", data);
    isOnline.value = true;
}

function handleNotSignedIn(data: object) {
    isOnline.value = true;
}

function handleOffline() {
    error.value = t.app.error.offline;
}

document.onclick = () => {
    playMusic("home");
    document.onclick = null;
};

return (_ctx: any,_cache: any) => {
  const _component_ToastList = _resolveComponent("ToastList")!
  const _component_RouteLoading = _resolveComponent("RouteLoading")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_HomeContainer = _resolveComponent("HomeContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$language.value && isOnline.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_ToastList),
            (_unref(isRouteLoading))
              ? (_openBlock(), _createBlock(_component_RouteLoading, { key: 0 }))
              : (_openBlock(), _createBlock(_component_router_view, {
                  key: _ctx.$language.value
                }))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_HomeContainer, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(error.value), 1)
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock(SpinnerIcon, {
                  key: 1,
                  class: "app-spinner"
                }))
          ]))
    ])
  ]))
}
}

})